// extracted by mini-css-extract-plugin
export default {"root":"HomePage_root__pEskZ"};